import React from "react";
import './startscreen.css'
function StartScreen() {
  return (
    <div className="StartScreen">
      <div>
        <div className="currency">
          <div className="currencytoshow">
            <div className="currencyratecards">
              <div className="currencyshowrate">85.123</div>
              <div className="currencyname">USD</div>
            </div>
            <div style={{borderRight:'1px solid #77757e',borderLeft:'1px solid #77757e'}}>
              <div className="currencyshowrate">89.123</div>
              <div className="currencyname">EUR</div>
            </div>
            <div>
              <div className="currencyshowrate">105.123</div>
              <div className="currencyname">GBP</div>
            </div>
          </div>
          <div style={{padding:'10px',marginTop:'30px',border:'none',font:'22px !important',boxShadow:'none'}}>
            <button className="ctabutton">Book Forex Now</button>
          </div>
        </div>
        </div>
    </div>
  );
}

export default StartScreen;